import {
  successAction,
  types,
  errorAction,
  requestAction,
} from "@authzsvc/api-lib";

const initialState = {
  loading: false,
  data: {},
};

const applications = (state = initialState, action) => {
  switch (action.type) {
    case errorAction(types.GET_APPLICATION):
      return { ...state, loading: false };
    case successAction(types.GET_APPLICATION):
      return { ...state, data: action.payload.data, loading: false };
    case requestAction(types.GET_APPLICATION):
      return { ...state, loading: true };
    default:
      return state;
  }
};

export default applications;
